import { useEffect, useState } from "react";
import { fetchPageData } from "../endpoint/pageApi";
import MainLayout from "../layouts/MainLayout";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../utils/mediaBreakpoints";
import PractitionersCarousel from "../components/Carousel/PractitionersCarousel";
import careerSec2 from ".././assets/image/careerSec2.png";
import careerSec2right from ".././assets/image/careerSec2right.png";
import TrustWorthyAI from "../components/SecurityComponents/TrustWorthyAI";
import CareerFourth from "../components/CareerFourth.js/CareerFourth";
import CareerFourthright from ".././assets/image/careerFourthRight.png";
import CareerJobs from "../components/CareerJobs/CareerJobs";
import careerCarousel1 from "../../src/assets/video/careerCarousel1.mp4";
import careerCarousel2 from "../../src/assets/video/careerCarousel2.mp4";
import careerCarousel3 from "../../src/assets/video/careerCarousel3.mp4";
import Item from "antd/es/list/Item";
import { baseUrl } from "../utils/base_url";

const MainCareersPage = ({ data, isMobile, jobs, cities, departments, natures, setCurrentPage,
  currentPage, pageSize, total

}) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  console.log("natu", natures);


  return (
    <>
      <div
        className="container-fluid m-0 p-0"
        style={{ backgroundColor: " #090D24" }}
      >
        <div className="row">
          <div className="col-12 pt-4 pb-5">
            <div className="container px-0 contwidth">
              {/* <div className="d-flex align-items-center justify-content-center pb-3">
                <img src={boximg} alt="" style={{ width: "100%" }} />
              </div> */}
              <PractitionersCarousel data={data} />

              <div className="text-center text-white w-100">
                <p
                  className="fw700 m-0 p-0 w-100 pt-3"
                  style={{
                    fontSize: _576
                      ? "30px"
                      : _768
                        ? "40px"
                        : _992
                          ? "49px"
                          : _1200
                            ? "54px"
                            : _1400
                              ? "60px"
                              : _1600
                                ? "65px"
                                : _1700
                                  ? "80px"
                                  : _1800
                                    ? "90px"
                                    : "90px",

                    lineHeight: _576
                      ? "30px"
                      : _768
                        ? "40px"
                        : _992
                          ? "49px"
                          : _1200
                            ? "54px"
                            : _1400
                              ? "59px"
                              : _1600
                                ? "64px"
                                : _1700
                                  ? "79px"
                                  : _1800
                                    ? "89px"
                                    : "100px",
                  }}
                >
                  {data?.about_header?.heading}
                  {/* The sun never sets at Ask
                  Fides */}
                </p>

                <p
                  dangerouslySetInnerHTML={{
                    __html: data?.about_header?.sub_heading?.replace(
                      "global business",
                      "<span style='color: #459EFF'>global business</span>"
                    ),
                  }}
                  className={`fw700 w-100 pt-4`}
                  style={{
                    padding: _992 ? "" : "0 7.5rem",
                    fontSize: _576
                      ? "15px"
                      : _768
                        ? "20px"
                        : _992
                          ? "20px"
                          : _1200
                            ? "23px"
                            : _1400
                              ? "26px"
                              : _1600
                                ? "29px"
                                : _1700
                                  ? "35px"
                                  : _1800
                                    ? "40px"
                                    : "40px",
                    lineHeight: "100%",
                    marginTop: "-1rem",
                    paddingBottom: "5rem",
                  }}
                ></p>
              </div>
            </div>
          </div>

          <div className="col-12 pb-5">
            <div className="container contwidth">
              <div className="row pb-5">
                {data?.practice_areas?.p_areas?.map((item, index) => {
                  return (
                    <>
                      <div key={index} className="col-12 col-md-6 px-0 py-4 py-md-0">
                        <div>
                          {/* <img
                            src={careerSec2}
                            style={{ width: "100%", height: "100%" }}
                          /> */}
                          {item?.image[0]?.mime?.includes("video") ? (
                            <div
                              style={{
                                height: "100%",
                                width: "100%",
                              }}
                            >
                              <video
                                autoPlay
                                loop
                                muted
                                // width={"100%"}
                                className=""
                                style={{
                                  objectFit: "cover",
                                  // height: "55vh",
                                  height: "100%",
                                  width: "100%",
                                  borderRadius: "20px",
                                }}
                              >
                                <source
                                  src={`${baseUrl}${item?.image[0]?.url}`}
                                  type="video/mp4"
                                />
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          ) : (
                            <img
                              className="d-block w-100"
                              style={{ objectFit: "cover", height: "55vh" }}
                              src={`${baseUrl}${item?.image[0]?.url}`}
                              alt="..."
                            />
                          )}
                        </div>
                        <p
                          className="text-center fw800 px-0 pt-3"
                          style={{
                            color: " #459EFF",
                            fontSize: _576
                              ? "20px"
                              : _768
                                ? "30px"
                                : _992
                                  ? "25px"
                                  : _1200
                                    ? "28px"
                                    : _1400
                                      ? "30px"
                                      : _1600
                                        ? "35px"
                                        : _1700
                                          ? "35px"
                                          : _1800
                                            ? "40px"
                                            : "45px",
                          }}
                        >
                          {item?.heading}
                          {/* Our practice areas and teams */}
                        </p>
                        <p
                          className="text-center text-white fw600 lh-1 px-5"
                          style={{
                            fontSize: _576
                              ? "14px"
                              : _768
                                ? "18px"
                                : _992
                                  ? "20px"
                                  : _1200
                                    ? "18px"
                                    : _1400
                                      ? "18px"
                                      : _1500
                                        ? "21px"
                                        : _1600
                                          ? "21px"
                                          : _1700
                                            ? "23px"
                                            : _1800
                                              ? "23px"
                                              : "26px",
                          }}
                        >
                          {item?.sub_heading}
                          {/* We serve our customers through our global businesses,
                          which are supported by our operational and functional
                          teams. You will have many ways to develop your career. */}
                        </p>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="col-12">
            <TrustWorthyAI
            // isMobile={isMobile}
            // data={pageData?.trustworthy_ai}
            />
          </div>

          <div className="col-12">
            <CareerFourth
              isMobile={isMobile}
              imgurl={data?.about_ask_fides?.image?.url}
              heading={data?.about_ask_fides?.super_heading}
              description={
                data?.about_ask_fides?.description
              }
              pointers={data?.about_ask_fides?.tool_pointers}
            />
          </div>

          <div className="col-12">
            <CareerJobs jobs={jobs}
              defaultCurrent={currentPage} pageSize={pageSize} total={total}
              setCurrentPage={setCurrentPage} natures={[natures]} departments={[departments]} cities={[cities]} />
          </div>
        </div>
      </div>
    </>
  );
};

const Careers = () => {
  const [pageData, setPageData] = useState({});
  const [jobData, setJobData] = useState([])
  const [natureData, setNatureData] = useState([])
  const [departmentData, setDepartmentData] = useState({})
  const [cityData, setCityData] = useState([])
  const [pagination, setPagingation] = useState({})

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchPageData("pages?filters[slug][$eq]=careers", setPageData, setLoader);
    fetchPageData("job-natures", setNatureData, setLoader);
    fetchPageData("job-cities", setCityData, setLoader);
    fetchPageData("job-departments", setDepartmentData, setLoader);
  }, []);

  useEffect(() => {
    fetchPageData(`fides-jobs?pagination[page]=${currentPage}&pagination[pageSize]=${pageSize}`, setJobData, setLoader, false, true, setPagingation);
  }, [currentPage])


  console.log(pagination)
  return (
    <>
      <MainLayout loader={loader}>
        <div className="container-fluid p-0 overflow-x-hidden">
          <MainCareersPage currentPage={pagination?.page} pageSize={pagination?.pageSize} total={pagination?.total} setCurrentPage={setCurrentPage} data={pageData} jobs={jobData} natures={natureData} departments={departmentData} cities={cityData} />
        </div>
      </MainLayout>
    </>
  );
};

export default Careers;
